
<div class="page-title">
  <h1><mat-icon color="primary">calendar_month</mat-icon>&nbsp;Prendre rendez-vous</h1>
</div>

<div class="row-page-content">
  <div class="adaptative-half-page-content">
    <div class="section">
      <iframe [src]="schedulingUrl | safeUrl" style="border: 0" width="100%" height="600px" frameborder="0"></iframe>
    </div>
  </div>
</div>